/** 报事系统 **/
import Layout from "@/views/layout/Layout";

const reportManRouter = {
  path: "/reportMan",
  component: Layout,
  name: "reportMan",
  meta: {
    title: "报事管理",
    icon: "dash-kqjg",
    roles: ["baoshiguanli_web"]
  },
  alwaysShow: true,
  children: [
    {
      path: "reportConfig",
      component: () => import("@/views/reportMan/reportConfig/index"),
      meta: {
        title: "报事设置",
        roles: ["baoshishezhi"]
      },
      alwaysShow: true,
      children: [
        {
          path: "buildingInformationMaintenance",
          component: () =>
            import("@/views/reportMan/reportConfig/buildingInformationMaintenance"),
          name: "楼栋管理",
          meta: {
            title: "楼栋管理",
            roles: ["loudongguanli"]
          }
        },
        {
          path: "reportArea",
          component: () => import("@/views/reportMan/reportConfig/reportArea"),
          name: "报事区域",
          meta: {
            title: "报事区域",
            roles: ["baoshiquyu"]
          }
        },
        {
          path: "reportSubjectModel",
          component: () =>
            import("@/views/reportMan/reportConfig/reportSubjectModel"),
          name: "报事科目设置",
          meta: {
            title: "报事科目设置",
            roles: ["baoshikemu"]
          }
        },
        {
          path: "reportSubject",
          component: () =>
            import("@/views/reportMan/reportConfig/reportSubject"),
          name: "项目报事科目",
          meta: {
            title: "项目报事科目",
            roles: ["baoshikemu"]
          }
        },
        {
          path: "dispatchConfig",
          component: () =>
            import("@/views/reportMan/reportConfig/dispatchConfig"),
          name: "派工设置",
          meta: {
            title: "派工设置",
            roles: ["paigongshezhi"]
          }
        },
        {
          path: "workOrderStep",
          component: () =>
            import("@/views/reportMan/reportConfig/workOrderStep"),
          name: "工单步骤",
          meta: {
            title: "工单步骤",
            roles: ["gongdanbuzhou"]
          }
        },
        {
          path: "schoolUserMan",
          component: () =>
            import("@/views/reportMan/reportConfig/schoolUserMan"),
          name: "校园端用户管理",
          meta: {
            title: "校园端用户管理",
            roles: ["schoolusermanager"]
          }
        },
      ]
    },
    {
      path: "reportManagement",
      component: () => import("@/views/reportMan/reportManagement/index"),
      name: "报事管理",
      meta: {
        title: "报事管理",
        roles: ["baoshiguanli2"]
      }
    },
    {
      path: "reportSupervise",
      component: () => import("@/views/reportMan/reportSupervise/index"),
      name: "报事监管",
      meta: {
        title: "报事监管",
        roles: ["baoshijianguan_web"]
      }
    },

    // 报表
    {
      path: "statisticalAnalysis",
      component: () => import("@/views/reportMan/statisticalAnalysis"),
      name: "统计分析",
      meta: {
        title: "统计分析",
        roles: ["baoshifenxi_web"]
      }
    },
    {
      path: "statisticalReports",
      component: () => import("@/views/reportMan/statisticalReports"),
      name: "统计报表",
      meta: {
        title: "统计报表",
        roles: ["baoshitongji_web"]
      }
    },
    {
      path: "orderRecords",
      component: () => import("@/views/reportMan/orderRecords"),
      name: "接单提示记录",
      meta: {
        title: "接单提示记录",
        roles: ["jiedantishijilu_web"]
      }
    },
     {
          path: "projectMaintenanceScope",
          component: () =>
            import("@/views/reportMan/reportConfig/projectMaintenanceScope"),
          name: "报事维修范围信息",
          meta: {
            title: "报事维修范围信息",
            roles: ["baoshiweixiuchakan"]
          }
        }
  ]
};

export default reportManRouter;